import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useProductDetailLogic from './ProductDetailLogic';
import BasicProductDetailSkin from './skins/BasicProductDetailSkin';
import ProductDetailProperties from './ProductDetail.properties';

/**
 * 상품 상세 스킨 가능 컴포넌트
 */
export const ProductDetailSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.PRODUCT_DETAIL,
  name: '상품 상세',
  category: 'ecommerce',
  supportsExternalSkins: true, // 외부 스킨 지원 활성화
  icon: '🛒',
  options: ProductDetailProperties as any,
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicProductDetailSkin as any
  },
  useLogic: useProductDetailLogic as any,
  defaultProps: {
    showDescriptionTab: true,
    showReviewsTab: true,
    showSpecificationTab: true,
    showStock: true,
    showRelatedProducts: true,
    showQuantitySelector: true,
    showAddToCart: true,
    showBuyNow: true,
    addToCartButtonColor: '#007bff',
    buyNowButtonColor: '#28a745',
    priceColor: '#ff6b6b',
    stockTextColor: '#28a745'
  }
};